<template>
  <div v-if="communication">
    <v-card :color="communicationColor.background" flat>
      <v-card-text>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-chip small :color="communicationColor.chip">
            <span v-if="author">
              {{ communication.type == "EDITOR" ? communication.type : "YOU" }}
            </span>
            <span v-else>{{ communication.type }}</span>
          </v-chip>
        </div>

        <section class="mt-2">
          <h3>{{ communication.subject }}</h3>
          <div class="abstract" v-html="communication.body"></div>

          <div class="mb-5" v-if="communication.attachment">
            <v-btn
              x-small
              outlined
              color="teal"
              :href="communication.attachment.location"
            >
              Download attachment
            </v-btn>
            <v-divider class="mt-3"></v-divider>
          </div>
        </section>

        <div class="d-flex" style="line-height: 1.2">
          <v-tooltip bottom v-if="!communication.emailed">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="deleteCommunication"
                v-if="!author"
                v-bind="attrs"
                outlined
                small
                icon
                color="red"
                v-on="on"
                class="mr-2"
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>Delete message</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="communication.type == 'EDITOR' && !communication.emailed"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="emailCommunication"
                v-if="!author"
                outlined
                small
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small> mdi-email </v-icon>
              </v-btn>
            </template>
            <span>Send by email</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <small>Sent: {{ formatDate(communication.createdAt) }}</small>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { formatDate } from "../../../tools/format";

export default {
  props: {
    communication: {
      type: Object,
      default: () => {},
    },
    author: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    deleting: false,
    emailing: false,
  }),

  computed: {
    communicationColor() {
      switch (this.communication.type) {
        case "EDITOR":
          return { chip: "blue white--text", background: "blue lighten-5" };

        default:
          return { chip: "orange white--text", background: "orange lighten-5" };
      }
    },
  },

  methods: {
    formatDate,
    deleteCommunication() {
      if (!this.communication._id || this.deleting) return;

      this.deleting = true;

      this.$axios({
        method: "DELETE",
        url: `/communications/${this.communication.manuscript}/${this.communication._id}`,
      })
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Communication removed",
          });

          this.$emit("refresh");
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not remove communication",
          });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    emailCommunication() {
      if (!this.communication._id || this.emailing) return;

      this.emailing = true;

      this.$axios({
        method: "POST",
        url: `/communications/sendmail/${this.communication._id}`,
      })
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Communication emailed",
          });

          this.$emit("refresh");
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not email communication",
          });
        })
        .finally(() => {
          this.emailing = false;
        });
    },
  },
};
</script>

<style>
</style>